<template>
    <div class="uzhnet-input-component">
        <div class="uzhnet-input-container">
            <input @input="$emit('update:modelValue', $event.target.value)" :value="modelValue" :type="contentType" class="uzhnet-input" :placeholder="placeholder">
            <svg width="100%" height="200%" viewBox="0 0 344 39" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M0.5 38.5V6.06082L6.20341 0.5H343.5V32.9392L337.797 38.5H0.5Z" fill="#C7C8D1" fill-opacity="0.1" stroke="#C7C8D1"/>
            </svg>
        </div>
    </div>
</template>
<script>
export default {
    name: "UzhnetInput",

    props: {
        placeholder: {
            type: String,
            default: 'Ваш текст...'
        },
        modelValue: {
            type: String,
            default: ''
        },
        alignText: {
            type: String,
            default: 'left'
        },
        contentType: {
            type: String,
            default: 'text'
        },
        fontSize: {
            type: String,
            default: '20px'
        }
    }
}
</script>
<style lang="scss" scoped>
.uzhnet-input-component {
    position: relative;
    height: max-content;
}

.uzhnet-input-container {
    position: relative;
    width: 100vw; /* Розтягує контейнер на всю ширину екрана */
    max-width: 100%; /* Гарантує відсутність обмежень */
    margin: 0;
    height: 100%; /* Висота SVG */
}

.uzhnet-input {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%; /* Розтягує input на всю ширину контейнера */
    height: 100%;
    border: none;
    background: transparent;
    padding: 0 15px;
    font-size: v-bind(fontSize);
    z-index: 1; /* Піднімає input над SVG */
    color: #E0C522;
    box-sizing: border-box;
    text-align: v-bind(alignText);
}

.uzhnet-input:focus {
    outline: none;
}
</style>
